import * as administrator from "./administrator";
import * as common from "./common";
import * as company from "./company";
const post = {
  administrator,
  common,
  company,
};

export default post;
